import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=4b70667c&scoped=true&"
import script from "./DataForm.vue?vue&type=script&lang=ts&"
export * from "./DataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70667c",
  null
  
)

export default component.exports